import config from 'devextreme/core/config';
import "devextreme/dist/css/dx.light.css";
import { loadMessages, locale } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import frMessages from 'devextreme/localization/messages/fr.json';
import nlMessages from 'devextreme/localization/messages/nl.json';
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import { Tabs, Tab, Button, Box, AppBar, Toolbar, ThemeProvider, CssBaseline, Menu, MenuItem } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import DailyComponentsOverviewPage from "./pages/DailyPlanningsOverviewPage";
import DailyHoursWorkedOverviewPage from "./pages/DailyHoursWorkedOverviewPage";
import DailyPlanningsPage from "./pages/DailyPlanningsPage";
import HomePage from "./pages/HomePage";
import MonthlyOverviewPage from "./pages/MonthlyOverviewPage";
import ProjectPivotPage from "./pages/ProjectPivotPage";
import WorkcellsPage from "./pages/ManageWorkcellsPage";
import OperatorsPage from "./pages/ManageOperatorsPage";
import UploadsPage from "./pages/UploadsPage";
import ActivityDataPage from "./pages/ActivityDataPage";
import DailyWorkcellSchedulePage from "./pages/DailyWorkcellActivityPage";
import DailyOperatorSchedulePage from "./pages/DailyOperatorSchedulePage";
import MonthlyWorkcellSchedulePage from './pages/MonthlyWorkcellActivityPage';
import WorkcellAppointmentsPage from "./pages/WorkcellAppointmentsDayPage";
import WorkcellAppointmentsMonthPage from "./pages/WorkcellAppointmentsMonthPage";
import { getAuthToken } from "./api";
import theme from './theme';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DailyOverviewPage from "./pages/DailyOverviewPage";
import MonthlyHoursWorkedOverviewPage from "./pages/MonthlyHoursWorkedOverviewPage";
import MonthlyPlanningsOverviewPage from "./pages/MonthlyPlanningsOverviewPage";
import MonthlyThroughputPerHourPage from "./pages/MonthlyThroughputPerHourPage";
import MonthlyWorkcellOeeSchedulerPage from './pages/MonthlyWorkcellOeeSchedulerPage';
import MonthlyPlanningsPage from "./pages/MonthlyPlanningsPage";
import WorkcellMonthlyOverviewPage from "./pages/WorkcellMonthlyOverviewPage";
import WorkcellDailyOverviewPage from "./pages/WorkcellDailyOverviewPage";
import WorkcellFactoryPage from "./pages/WorkcellFactoryPage";
import WorkcellLandingPage from "./pages/WorkcellLandingPage";
import WorkcellStatsGridDemoPage from "./pages/WorkcellStatsGridDemoPage";
import ErrorLogPage from './pages/ErrorLogPage';
import DataFilesPage from './pages/DataFilesPage';
import CustomersPage from './pages/CustomersPage';
import DeleteTimeslotPage from './pages/DeleteTimeslotPage';
import AdminPage from './pages/AdminPage';
import LogoutPage from './pages/LogoutPage';
import { useTranslation } from "react-i18next";
import { CustomerSettingsProvider, useCustomerSettings } from "./context/CustomerSettingsContext";
import GeneralSettingsPage from "./pages/GeneralSettingsPage";


config({ licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImVkMjU2YWEwLWRlMjEtNDFhZS05ZWFmLTU5OGQzZTQ4ZjAyMCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.Ypl4g2o+9WXAFXX3p9L1jsl5vuIWItqtMEg/L8+SyvdKgiCkQuqnokNZHuWAeaSH0t3fnxTJQtWWRTDXKEcrZWBSGeGQF8WoBqkVNfbCLZUlyB5MpVFXIigvD1g2fzhT3nXn7g==' });
loadMessages(deMessages);
loadMessages(frMessages);
loadMessages(nlMessages);

const AppContent = () => {
  const { t } = useTranslation();
  const { regionFormattingLocale } = useCustomerSettings();

  useEffect(() => {
    getAuthToken();
  }, []);

  useEffect(() => {
    locale(regionFormattingLocale || 'en-GB');
  }, [regionFormattingLocale]);

  return (
    <Router>
      <AppBar position="static">
        <Toolbar sx={{ height: '64px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 4, height: '64px'}}>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', height: '64px' }}>
              <img src="/logo-small.png" alt={t("app.logoAlt")} style={{ height: '50%', marginRight: '12px' }} />
              <img src="/logo.png" alt={t("app.logoAltAnalytics")} style={{ height: '35%' }} />
            </Link>
          </Box>
          <TabNavigation />
        </Toolbar>
      </AppBar>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/activity-data" element={<ActivityDataPage />} />
        <Route path="/activity-data/:date" element={<ActivityDataPage />} />
        <Route path="/data-files" element={<DataFilesPage />} />
        <Route path="/data-files/*" element={<DataFilesPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/timeslots/delete" element={<DeleteTimeslotPage />} />
        <Route path="/chart/daily/overview" element={<DailyOverviewPage />} />
        <Route path="/chart/daily/overview/:date" element={<DailyOverviewPage />} />
        <Route path="/chart/daily/hours/:date" element={<DailyHoursWorkedOverviewPage />} />
        <Route path="/chart/daily/operator-schedule/:date" element={<DailyOperatorSchedulePage />} />
        <Route path="/chart/daily/plannings/:date" element={<DailyComponentsOverviewPage />} />
        <Route path="/chart/daily/plannings/:date/:workcell_id" element={<DailyPlanningsPage />} />
        <Route path="/chart/daily/workcell-schedule/:date" element={<DailyWorkcellSchedulePage />} />
        <Route path="/chart/monthly/overview" element={<MonthlyOverviewPage />} />
        <Route path="/chart/monthly/overview/:date" element={<MonthlyOverviewPage />} />
        <Route path="/chart/monthly/plannings/:date" element={<MonthlyPlanningsOverviewPage />} />
        <Route path="/chart/monthly/plannings/:date/:workcell_id" element={<MonthlyPlanningsPage />} />
        <Route path="/chart/monthly/workcell-schedule/:date" element={<MonthlyWorkcellSchedulePage />} />
        <Route path="/chart/monthly/hours-worked/:date" element={<MonthlyHoursWorkedOverviewPage />} />
        <Route path="/chart/monthly/throughput-per-hour/:date" element={<MonthlyThroughputPerHourPage />} />
        <Route path="/chart/monthly/oee/:date" element={<MonthlyWorkcellOeeSchedulerPage />} />
        <Route path="/operators" element={<OperatorsPage />} />
        <Route path="/pivot/project" element={<ProjectPivotPage />} />
        <Route path="/pivot/project/:project_id" element={<ProjectPivotPage />} />
        <Route path="/settings/general" element={<GeneralSettingsPage />} />
        <Route path="/uploads" element={<UploadsPage />} />
        <Route path="/workcell-appointments-month" element={<WorkcellAppointmentsMonthPage />} />
        <Route path="/workcell-appointments-month/:workcell_id" element={<WorkcellAppointmentsMonthPage />} />
        <Route path="/workcell-appointments" element={<WorkcellAppointmentsPage />} />
        <Route path="/workcell-appointments/:workcell_id/:date" element={<WorkcellAppointmentsPage />} />
        <Route path="/workcells" element={<WorkcellsPage />} />
        <Route path="/chart/workcell/:workcell_id/monthly/:date" element={<WorkcellMonthlyOverviewPage />} />
        <Route path="/chart/workcell/:workcell_id/daily/:date" element={<WorkcellDailyOverviewPage />} />
        <Route path="/workcell-landing" element={<WorkcellLandingPage />} />
        <Route path="/workcell-factory-view" element={<WorkcellFactoryPage />} />
        <Route path="/workcell-stats-grid-demo" element={<WorkcellStatsGridDemoPage />} />
        <Route path="/errors" element={<ErrorLogPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
    </Router>
  );
};

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CustomerSettingsProvider>
          <AppContent />
        </CustomerSettingsProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

const TabNavigation = () => {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  const tabMapping = [
    // { path: /^\/$/, index: 0 },
    { path: /^\/chart\/daily/, index: 0 },
    { path: /^\/chart\/monthly/, index: 1 },
    { path: /^\/chart\/workcell/, index: 2 },
    { path: /^\/workcell/, index: 2 },
    { path: /^\/pivot\/project/, index: 3 },
  ];

  const currentTab = tabMapping.find(tab => tab.path.test(location.pathname))?.index ?? 0;

  // detect a YYYY-MM-DD date at the end of the current pathname (optional)
  const dateMatch = location.pathname.match(/\/(\d{4}-\d{2}-\d{2})(?:\/)?$/);
  const dateParam = dateMatch?.[1];

  // build links that include the date only when present
  const dailyLink = dateParam ? `/chart/daily/overview/${dateParam}` : '/chart/daily/overview/';
  const monthlyLink = dateParam ? `/chart/monthly/overview/${dateParam}` : '/chart/monthly/overview/';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
      <Tabs value={currentTab} sx={{ flexGrow: 1 }}>
        {/* <Tab label="Home" component={Link} to="/" /> */}
        <Tab label={t("nav.daily")} component={Link} to={dailyLink} />
        <Tab label={t("nav.monthly")} component={Link} to={monthlyLink} />
        <Tab label={t("nav.workcells")} component={Link} to="/workcell-landing" />
        <Tab label={t("nav.project")} component={Link} to="/pivot/project" />
      </Tabs>
      <Button
        variant="navDropdown"
        onClick={handleSettingsClick}
        startIcon={<SettingsIcon />}
        endIcon={<KeyboardArrowDownIcon />}
      >{t("nav.settings")}</Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleSettingsClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem component={Link} to="/settings/general" onClick={handleSettingsClose}>{t("nav.menu.general")}</MenuItem>
        <MenuItem component={Link} to="/workcells" onClick={handleSettingsClose}>{t("nav.menu.workcells")}</MenuItem>
        <MenuItem component={Link} to="/operators" onClick={handleSettingsClose}>{t("nav.menu.operators")}</MenuItem>
        <MenuItem component={Link} to="/workcell-appointments-month" onClick={handleSettingsClose}>{t("nav.menu.workcellCalendar")}</MenuItem>
      </Menu>
    </Box>
  );
};

export default App;
